import React from "react";
import { useParams, Navigate } from "react-router-dom";
import { useAuthState } from "react-firebase-hooks/auth";
import { auth } from "../../firebase";
import clientData from "../../utils/clientData.json";
import AlbumCard from "../AlbumCard/AlbumCard"; // Reuse the AlbumCard component
import "../PortfolioPage/PortfolioPage.css"; // Reuse the PortfolioPage styles

function ClientDashboard() {
  const { clientId } = useParams();
  const [user, loading] = useAuthState(auth);

  // Find the specific client's data using the ID from the URL
  const client = clientData.find((c) => c.clientID === clientId);

  if (loading) {
    return (
      <div className="portfolio-container">
        <h1>Loading...</h1>
      </div>
    );
  }

  // If no user is logged in, redirect to the login page
  if (!user) {
    return <Navigate to="/client" replace />;
  }

  // If the URL ID is invalid or doesn't match the logged-in user's email
  if (
    !client ||
    user.email.toLowerCase() !== client.clientEmail.toLowerCase()
  ) {
    // You can show an "Access Denied" message or redirect
    return <Navigate to="/client" replace />;
  }

  return (
    <div className="portfolio-container">
      <header className="portfolio-header">
        <h1>Welcome, {client.clientName}!</h1>
        <p>Thank you for choosing TjWit Media. Here are your albums.</p>
      </header>
      <div className="portfolio-grid">
        {client.albums.map((album, index) => (
          <AlbumCard
            key={index}
            name={album.displayName}
            previewImage={album.albumPicture}
            link={album.albumLink}
            delay={`${index * 100}ms`}
          />
        ))}
      </div>
    </div>
  );
}

export default ClientDashboard;
